import pythonApiClient from './pythonBaseApi';

/**
 * Servicio para gestión de trabajadores
 * Maneja todas las operaciones relacionadas con trabajadores
 */
export const trabajadorApi = {
  /**
   * Valida archivo Excel antes de procesarlo (solo validación, sin procesar)
   * @param {File} file - Archivo Excel
   * @param {number|null} empresaColaboradoraId - ID de la empresa colaboradora (opcional)
   * @param {number|null} clienteId - ID del cliente (opcional)
   * @param {boolean} skipDniValidation - Si es true, salta la validación de longitud de DNI (opcional)
   * @param {boolean} skipDuplicateDniValidation - Si es true, permite DNI duplicados (opcional)
   * @param {boolean} autoCompleteDniLength - Si es true, completa con ceros a la izquierda según tipo de documento (opcional)
   * @returns {Promise} - Respuesta de la API con resultado de validación
   */
  validateBulkUploadFile: (file, empresaColaboradoraId = null, clienteId = null, skipDniValidation = false, skipDuplicateDniValidation = false, autoCompleteDniLength = false) => {
    const formData = new FormData();
    formData.append('file', file);
    if (empresaColaboradoraId) {
      formData.append('empresa_colaboradora_id', empresaColaboradoraId);
    }
    if (clienteId) {
      formData.append('cliente_id', clienteId);
    }
    if (skipDniValidation) {
      formData.append('skip_dni_validation', 'true');
    }
    if (skipDuplicateDniValidation) {
      formData.append('skip_duplicate_dni_validation', 'true');
    }
    if (autoCompleteDniLength) {
      formData.append('auto_complete_dni_length', 'true');
    }

    return pythonApiClient.post('/procesos/hoteleria/carga-masiva/trabajadores/validate', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      // El endpoint siempre devuelve 200 OK, incluso con errores de validación
      // Los errores de validación se incluyen en el cuerpo de la respuesta
    });
  },

  /**
   * Carga masiva de trabajadores desde archivo Excel
   * @param {File} file - Archivo Excel
   * @param {number|null} empresaColaboradoraId - ID de la empresa colaboradora (opcional)
   * @param {number} clienteId - ID del cliente
   * @param {boolean} skipDniValidation - Si es true, salta la validación de longitud de DNI (opcional)
   * @param {boolean} skipDuplicateDniValidation - Si es true, permite DNI duplicados (opcional)
   * @param {boolean} autoCompleteDniLength - Si es true, completa con ceros a la izquierda según tipo de documento (opcional)
   * @returns {Promise} - Respuesta de la API
   */
  bulkUpload: (file, empresaColaboradoraId, clienteId, skipDniValidation = false, skipDuplicateDniValidation = false, autoCompleteDniLength = false) => {
    const formData = new FormData();
    formData.append('file', file);
    if (empresaColaboradoraId) {
      formData.append('empresa_colaboradora_id', empresaColaboradoraId);
    }
    formData.append('cliente_id', clienteId);
    if (skipDniValidation) {
      formData.append('skip_dni_validation', 'true');
    }
    if (skipDuplicateDniValidation) {
      formData.append('skip_duplicate_dni_validation', 'true');
    }
    if (autoCompleteDniLength) {
      formData.append('auto_complete_dni_length', 'true');
    }

    return pythonApiClient.post('/procesos/hoteleria/carga-masiva/trabajadores', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  /**
   * Obtener reporte de trabajadores
   * @param {Object} filtros - Filtros para el reporte (proyecto_id, cliente_id, empresa_colaboradora_id, activo)
   * @param {number} proyectoId - ID del proyecto (para header)
   * @returns {Promise} - Respuesta de la API con el reporte
   */
  getReporte: (filtros, proyectoId) => {
    const params = {};
    if (filtros.proyecto_id) params.proyecto_id = filtros.proyecto_id;
    if (filtros.cliente_id) params.cliente_id = filtros.cliente_id;
    if (filtros.empresa_colaboradora_id) params.empresa_colaboradora_id = filtros.empresa_colaboradora_id;
    if (filtros.activo !== undefined && filtros.activo !== null) params.activo = filtros.activo;

    return pythonApiClient.get('/procesos/hoteleria/carga-masiva/trabajadores/reporte', {
      params,
      headers: {
        'X-Proyecto-ID': proyectoId,
      },
    });
  },
};

export default trabajadorApi;
